/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { NavLink, useLocation } from "react-router-dom";
// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";
import Link from "@mui/material/Link";
import List from "@mui/material/List";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import SidenavCollapse from "examples/Sidenav/SidenavCollapse";
import SidenavRoot from "examples/Sidenav/SidenavRoot";
import { menuAction } from "ReduxReducers/menuReducer";
import {
  setMiniSidenav,
  setTransparentSidenav,
  setWhiteSidenav,
  useMaterialUIController,
} from "context";
import { useDispatch } from "react-redux";
import { IconButton } from '@mui/material';
import { RiMenuUnfold3Line2 } from "react-icons/ri";
import { RiMenuUnfold4Line2 } from "react-icons/ri";


function Sidenav({ color, brand, brandName, routes, ...rest }) {
  const [controller, dispatch] = useMaterialUIController();
  const reDispatch = useDispatch()
  const { miniSidenav, transparentSidenav, whiteSidenav, darkMode } = controller;
  const location = useLocation();
  const pathSegments = window.location.pathname.split('/');
  let collapseName = pathSegments[1]
  let textColor = "white";

  if (transparentSidenav || (whiteSidenav && !darkMode)) {
    textColor = "dark";
  } else if (whiteSidenav && darkMode) {
    textColor = "inherit";
  }

  const [onMouseEnter, setOnMouseEnter] = useState(false);
  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      // setMiniSidenav(dispatch, true);
      // setOnMouseEnter(false);
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  useEffect(() => {
    // A function that sets the mini state of the sidenav.
    function handleMiniSidenav() {
      // setMiniSidenav(dispatch, window.innerWidth < 1200);
      setMiniSidenav(dispatch, true);
      setTransparentSidenav(dispatch, window.innerWidth < 1200 ? false : transparentSidenav);
      setWhiteSidenav(dispatch, window.innerWidth < 1200 ? false : whiteSidenav);
    }

    /** 
     The event listener that's calling the handleMiniSidenav function when resizing the window.
    */
    window.addEventListener("resize", handleMiniSidenav);

    // Call the handleMiniSidenav function to set the state with the initial value.
    handleMiniSidenav();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleMiniSidenav);
  }, [dispatch, location]);


  useEffect(() => {
    setMiniSidenav(dispatch, true);
  }, [])



  // Render all the routes from the routes.js (All the visible items on the Sidenav)
  const [dropOpen, setDropOpen] = useState(Array(routes.length).fill(false));
  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);

  const setOpen = (index) => {
    const updatedOpenState = dropOpen.map((value, i) => (i === index ? !value : false));
    setDropOpen(updatedOpenState);
  };


  const renderRoutes = routes.filter(val => JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'))?.userType.toLowerCase() === val.user).map(
    ({ type, name, icon, title, noCollapse, match, option, key, href, route, permission }, index) => {
      let returnValue;

      if (type === "collapse") {
        if (permission !== "None" && permission !== undefined) {
          returnValue = href ? (
            <Link
              href={href}
              key={key}
              target="_blank"
              rel="noreferrer"
              sx={{ textDecoration: "none" }}
            >
              <SidenavCollapse
                name={name}
                icon={icon}
                active={key === collapseName}
                noCollapse={noCollapse}

              />
            </Link>
          ) : (
            <NavLink key={key} to={collapseName === route.split("/")[1] ? `/b?screen=${route}` : route}>
              <SidenavCollapse
                // onMouseEnter={handleOnMouseEnter}
                // onMouseLeave={handleOnMouseLeave} 
                name={name} icon={icon} active={key === collapseName}

              />
            </NavLink>
          );
        } else {

          returnValue = (

            <SidenavCollapse
              onClick={() => reDispatch(menuAction(true))}
              // onMouseEnter={handleOnMouseEnter}
              // onMouseLeave={handleOnMouseLeave} 
              name={name} icon={icon} active={key === collapseName}

            />

          )



        }

      } else if (type === "title") {
        returnValue = (
          <MDTypography
            key={key}
            color={textColor}
            display="block"
            variant="caption"
            fontWeight="bold"
            textTransform="uppercase"
            pl={3}
            mt={2}
            mb={1}
            ml={1}
          >
            {title}
          </MDTypography>
        );
      } else if (type === "divider") {
        returnValue = (
          <Divider
            key={key}
            light={
              (!darkMode && !whiteSidenav && !transparentSidenav) ||
              (darkMode && !transparentSidenav && whiteSidenav)
            }
          />
        );
      } else if (type === "option") {



        if (permission !== "None" && permission !== undefined) {
          returnValue = (
            <>
              <SidenavCollapse
                name={name}
                icon={icon}
                active={key === collapseName}
                noCollapse={noCollapse}
                onClick={() => setOpen(index)}
                // onMouseEnter={handleOnMouseEnter}
                // onMouseLeave={handleOnMouseLeave} 
                iconUsed={true}
                sideIcon={dropOpen[index] ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
              />

              {dropOpen[index] && <>
                {option.map((val, i) => {
                  return (
                    <>
                      {(val.permission !== "None" && val.permission !== undefined)
                        ? <NavLink className="optionValues"
                          sx={{ textDecoration: "none" }} key={key} to={collapseName === val.route.split("/")[1] ? `/b?screen=${val.route}` : val.route}>
                          <SidenavCollapse name={val.name}
                            newSet={true}
                            icon={val.icon}
                            active={val.key === collapseName}
                            noCollapse={noCollapse} ></SidenavCollapse></NavLink>
                        : <SidenavCollapse name={val.name}
                          newSet={true}
                          icon={val.icon}
                          onClick={() => reDispatch(menuAction(true))}
                          active={val.key === collapseName}
                          noCollapse={noCollapse} ></SidenavCollapse>

                      }</>)
                }
                )
                }</>}

            </>
          );

        } else {
          returnValue = (
            <>
              <SidenavCollapse
                name={name}
                icon={icon}
                active={key === collapseName}
                noCollapse={noCollapse}
                onClick={() => reDispatch(menuAction(true))}
                // onMouseEnter={handleOnMouseEnter}
                // onMouseLeave={handleOnMouseLeave} 
                iconUsed={true}
                sideIcon={dropOpen[index] ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
              />



            </>
          );


        }

      }

      return returnValue;
    }
  );



  return (
    <SidenavRoot
      {...rest}
      variant="permanent"
      ownerState={{ transparentSidenav, whiteSidenav, miniSidenav, darkMode }}
    >
      <MDBox pb={-5} px={4} textAlign="center">
        <MDBox display="flex" alignItems="center">
          {/* {brand && <MDBox component="img" src={brand} alt="Brand" width="2rem" />} */}
          <MDBox
            width={!brandName && "100%"}
            // sx={(theme) => sidenavLogoLabel(theme, { miniSidenav })}
            style={{ display: "flex" }}
            pt={2}
          >


            <MDTypography component="h4" fontWeight="medium" color={textColor}  >
              <IconButton
                size="small"
                color="inherit"
                //  disableRipple
                onClick={handleMiniSidenav}
              >
                <Icon style={{ marginLeft: "0px" }} fontSize="large">
                  {miniSidenav ? <RiMenuUnfold3Line2 /> : <RiMenuUnfold4Line2 />}
                </Icon>
              </IconButton>
            </MDTypography>



            <MDTypography mt={1.5} component="h4" fontWeight="medium" color={textColor} >
              <div style={{ fontSize: "14px", marginLeft: "20px" }}>
                {brandName}
              </div>
            </MDTypography>
          </MDBox>
        </MDBox>
      </MDBox>
      <Divider
        light={
          (!darkMode && !whiteSidenav && !transparentSidenav) ||
          (darkMode && !transparentSidenav && whiteSidenav)
        }
      />

      <List sx={{ height: "auto", }}
        onMouseEnter={handleOnMouseEnter}
        onMouseLeave={handleOnMouseLeave}
      // onClick={() => { window.location.reload(true) }}
      >
        {renderRoutes}
      </List>
    </SidenavRoot>
  );
}

// Setting default values for the props of Sidenav
Sidenav.defaultProps = {
  color: "info",
  brand: "",
};

// Typechecking props for the Sidenav
Sidenav.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  brand: PropTypes.string,
  brandName: PropTypes.string.isRequired,
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Sidenav;
